import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Dropdown } from 'primereact/dropdown'
import { Toast } from 'primereact/toast'
import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import apis from '../../api'
import SkeletonTable from '../SkeletonTable/SkeletonTable'
import useWindowDimensions from '../hooks/useDimensions';

const Instances = () => {

    const [loadPage, setLoadPage] = useState(false)
    const [loading, setLoading] = useState(false)
    const [instancia, setInstancia] = useState("")
    const [accion, setAccion] = useState("")

    const [listaInstancias, setListaInstancias] = useState([])
    const [listaAcciones, setListaAcciones] = useState([])

    const cardStyle = {
        width: "90vw", marginBottom: "1rem", justifyContent: "center", display: 'block',
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.06), 0px 7px 9px rgba(0, 0, 0, 0.12), 0px 20px 25px -8px rgba(0, 0, 0, 0.18)'
    }

    const headers = { Authorization: localStorage.getItem("token") }

    const toast = useRef(null);

    const { width } = useWindowDimensions()

    useEffect(() => {
        const getLists = async () => {
            await apis.getInstanceLists(headers).then(res => {
                let data = res.data
                let instancias = data.INSTANCES
                let acciones = data.INSTANCES_ACTION

                setListaInstancias(instancias)
                setListaAcciones(acciones)
                setLoadPage(true)
            })
        }
        getLists()
    }, [])

    const postInstance = async () => {
        setLoading(true)
        const instance = instancia.detail_id
        const action = accion.detail_id

        const payload = {
            INSTANCE: instance,
            ACTION: action
        }

        try {
            await apis.postInstanceAction(payload, headers).then(res => {
                let data = res.data
                let type = ""
                let msg = ""
                let sum = ""
                if (data.WARNING) {
                    type = 'warn'
                    msg = data.WARNING
                    sum = 'Aviso'
                }
                else {
                    type = 'success'
                    msg = data.MESSAGE_AWS
                    sum = 'Éxito'
                }
                toast.current.show({ severity: type, summary: sum, detail: msg });
                setLoading(false)
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading(false)
        }
    }

    return (
        <div className="flex flex-column align-items-center justify-content-center card-container mt-6">
            <Toast ref={toast} />
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5 mb-4">
                <span className="text-900">Administración instancias</span>
            </div>
            <SkeletonTable load={loadPage} width="80vw">
                <div className='flex justify-content-center align-items-center'>
                    <Card style={cardStyle}>
                        <div className='flex flex-row justify-content-around'>
                            <div className="flex flex-column justify-content-center mt-2 mb-4"
                                style={{ flexDirection: width < 443 ? 'column' : 'row', width: width > 732 && '20vw' }}>
                                <div className="flex flex-column text-left">
                                    <label>Instancia</label>
                                    <Dropdown
                                        value={instancia} optionLabel="description"
                                        filter showClear filterBy="description" emptyMessage={"No hay instancias disponibles"}
                                        options={listaInstancias} placeholder={instancia ? instancia.description : "Seleccione"}
                                        onChange={(e) => setInstancia(e.value)}
                                    />
                                </div>
                                &nbsp;
                                <div className="flex flex-column text-left">
                                    <label>Acción</label>
                                    <Dropdown
                                        value={accion} optionLabel="description"
                                        filter showClear filterBy="description" emptyMessage={"No hay acciones disponibles"}
                                        options={listaAcciones} placeholder={accion ? accion.description : "Seleccione"}
                                        onChange={(e) => { setAccion(e.value); console.log(e.value) }}
                                    />
                                </div>
                                &nbsp;
                                <Button label='Aceptar' loading={loading}
                                    disabled={(instancia === '' || accion === '') || (instancia === undefined || accion === undefined)}
                                    onClick={() => postInstance()}
                                />
                            </div>
                            <img class="w-5 shadow-4" style={{ borderRadius: "50px", display: width < 732 && 'none' }} src={process.env.REACT_APP_SUPPORT} alt="Hola" />
                        </div>
                    </Card>
                </div>
            </SkeletonTable>
        </div>
    )
}

export default Instances
